export default {"src":"/_next/static/media/close.a9521f5f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};